import React, { PropTypes } from 'react'
import { Field } from 'react-redux-form/immutable'
import errBlock from 'bisu-react-form-error'

const InputRadio = ({ model, label, options, required }) => (
  <Field model={model}>
    <label htmlFor={label}>{label} {required && <span className="req">*</span>}</label>
    {options.map((item) => (
      <label key={item.value} htmlFor={item.value} className="radio-inline">
        <input type="radio" id={item.value} value={item.value} />
        <span>{item.label}</span>
      </label>
    ))}
    {errBlock(model)}
  </Field>
)

InputRadio.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  options: PropTypes.array,
  required: PropTypes.bool,
}

export default InputRadio



// WEBPACK FOOTER //
// ./src/components/InputRadio/index.js